/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Root2Inputs */

const en_coinvestments_dataroom_root2 = /** @type {(inputs: Coinvestments_Dataroom_Root2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Root`)
};

/**
* | output |
* | --- |
* | "Root" |
*
* @param {Coinvestments_Dataroom_Root2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_root2 = /** @type {((inputs?: Coinvestments_Dataroom_Root2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Root2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_root2(inputs)
});
export { coinvestments_dataroom_root2 as "coInvestments_dataRoom_root" }